import React from 'react';

// Reusable inline SVG icons — replace all emoji usage across the panel
// Each icon accepts size (default 14) and color (default 'currentColor')

const d = (size, color, paths, fill) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={fill ? color : 'none'} stroke={fill ? 'none' : color} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" style={{ display: 'inline-block', verticalAlign: '-0.15em', flexShrink: 0 }}>
    {paths}
  </svg>
);

export const IconRocket = ({ size = 14, color = 'currentColor' }) => d(size, color, <>
  <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 00-2.91-.09z" />
  <path d="M12 15l-3-3a22 22 0 012-3.95A12.88 12.88 0 0122 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 01-4 2z" />
  <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0" /><path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5" />
</>);

export const IconServer = ({ size = 14, color = 'currentColor' }) => d(size, color, <>
  <rect x="2" y="2" width="20" height="8" rx="2" ry="2" /><rect x="2" y="14" width="20" height="8" rx="2" ry="2" />
  <line x1="6" y1="6" x2="6.01" y2="6" /><line x1="6" y1="18" x2="6.01" y2="18" />
</>);

export const IconFolder = ({ size = 14, color = 'currentColor' }) => d(size, color, <>
  <path d="M22 19a2 2 0 01-2 2H4a2 2 0 01-2-2V5a2 2 0 012-2h5l2 3h9a2 2 0 012 2z" />
</>);

export const IconUsers = ({ size = 14, color = 'currentColor' }) => d(size, color, <>
  <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" /><circle cx="9" cy="7" r="4" />
  <path d="M23 21v-2a4 4 0 00-3-3.87" /><path d="M16 3.13a4 4 0 010 7.75" />
</>);

export const IconUser = ({ size = 14, color = 'currentColor' }) => d(size, color, <>
  <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" /><circle cx="12" cy="7" r="4" />
</>);

export const IconSwords = ({ size = 14, color = 'currentColor' }) => d(size, color, <>
  <polyline points="14.5 17.5 3 6 3 3 6 3 17.5 14.5" /><line x1="13" y1="19" x2="19" y2="13" />
  <line x1="16" y1="16" x2="20" y2="20" /><line x1="19" y1="21" x2="21" y2="19" />
  <polyline points="14.5 6.5 18 3 21 3 21 6 17.5 9.5" /><line x1="5" y1="14" x2="9" y2="18" />
  <line x1="7" y1="17" x2="4" y2="20" /><line x1="3" y1="19" x2="5" y2="21" />
</>);

export const IconClipboard = ({ size = 14, color = 'currentColor' }) => d(size, color, <>
  <path d="M16 4h2a2 2 0 012 2v14a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2h2" />
  <rect x="8" y="2" width="8" height="4" rx="1" ry="1" />
</>);

export const IconMap = ({ size = 14, color = 'currentColor' }) => d(size, color, <>
  <polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6" />
  <line x1="8" y1="2" x2="8" y2="18" /><line x1="16" y1="6" x2="16" y2="22" />
</>);

export const IconHardDrive = ({ size = 14, color = 'currentColor' }) => d(size, color, <>
  <line x1="22" y1="12" x2="2" y2="12" />
  <path d="M5.45 5.11L2 12v6a2 2 0 002 2h16a2 2 0 002-2v-6l-3.45-6.89A2 2 0 0016.76 4H7.24a2 2 0 00-1.79 1.11z" />
  <line x1="6" y1="16" x2="6.01" y2="16" /><line x1="10" y1="16" x2="10.01" y2="16" />
</>);

export const IconGlobe = ({ size = 14, color = 'currentColor' }) => d(size, color, <>
  <circle cx="12" cy="12" r="10" /><line x1="2" y1="12" x2="22" y2="12" />
  <path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z" />
</>);

export const IconBook = ({ size = 14, color = 'currentColor' }) => d(size, color, <>
  <path d="M4 19.5A2.5 2.5 0 016.5 17H20" /><path d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z" />
</>);

export const IconZap = ({ size = 14, color = 'currentColor' }) => d(size, color, <>
  <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
</>, true);

export const IconSettings = ({ size = 14, color = 'currentColor' }) => d(size, color, <>
  <circle cx="12" cy="12" r="3" />
  <path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-2 2 2 2 0 01-2-2v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83 0 2 2 0 010-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 01-2-2 2 2 0 012-2h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 010-2.83 2 2 0 012.83 0l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 012-2 2 2 0 012 2v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 0 2 2 0 010 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 012 2 2 2 0 01-2 2h-.09a1.65 1.65 0 00-1.51 1z" />
</>);

export const IconEdit = ({ size = 14, color = 'currentColor' }) => d(size, color, <>
  <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" />
  <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" />
</>);

export const IconTrash = ({ size = 14, color = 'currentColor' }) => d(size, color, <>
  <polyline points="3 6 5 6 21 6" /><path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2" />
</>);

export const IconPaperclip = ({ size = 14, color = 'currentColor' }) => d(size, color, <>
  <path d="M21.44 11.05l-9.19 9.19a6 6 0 01-8.49-8.49l9.19-9.19a4 4 0 015.66 5.66l-9.2 9.19a2 2 0 01-2.83-2.83l8.49-8.48" />
</>);

export const IconFileText = ({ size = 14, color = 'currentColor' }) => d(size, color, <>
  <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" /><polyline points="14 2 14 8 20 8" />
  <line x1="16" y1="13" x2="8" y2="13" /><line x1="16" y1="17" x2="8" y2="17" /><polyline points="10 9 9 9 8 9" />
</>);

export const IconShield = ({ size = 14, color = 'currentColor' }) => d(size, color, <>
  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
</>);

export const IconImage = ({ size = 14, color = 'currentColor' }) => d(size, color, <>
  <rect x="3" y="3" width="18" height="18" rx="2" ry="2" /><circle cx="8.5" cy="8.5" r="1.5" />
  <polyline points="21 15 16 10 5 21" />
</>);

export const IconRefresh = ({ size = 14, color = 'currentColor' }) => d(size, color, <>
  <polyline points="23 4 23 10 17 10" /><polyline points="1 20 1 14 7 14" />
  <path d="M3.51 9a9 9 0 0114.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0020.49 15" />
</>);

export const IconAlertTriangle = ({ size = 14, color = 'currentColor' }) => d(size, color, <>
  <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
  <line x1="12" y1="9" x2="12" y2="13" /><line x1="12" y1="17" x2="12.01" y2="17" />
</>);

export const IconTrophy = ({ size = 14, color = 'currentColor' }) => d(size, color, <>
  <path d="M6 9H4.5a2.5 2.5 0 010-5H6" /><path d="M18 9h1.5a2.5 2.5 0 000-5H18" />
  <path d="M4 22h16" /><path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22" />
  <path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22" />
  <path d="M18 2H6v7a6 6 0 0012 0V2z" />
</>);

export const IconCrosshair = ({ size = 14, color = 'currentColor' }) => d(size, color, <>
  <circle cx="12" cy="12" r="10" /><line x1="22" y1="12" x2="18" y2="12" /><line x1="6" y1="12" x2="2" y2="12" />
  <line x1="12" y1="6" x2="12" y2="2" /><line x1="12" y1="22" x2="12" y2="18" />
</>);

export const IconBarChart = ({ size = 14, color = 'currentColor' }) => d(size, color, <>
  <line x1="12" y1="20" x2="12" y2="10" /><line x1="18" y1="20" x2="18" y2="4" /><line x1="6" y1="20" x2="6" y2="16" />
</>);

export const IconMessageCircle = ({ size = 14, color = 'currentColor' }) => d(size, color, <>
  <path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z" />
</>);

export const IconFlag = ({ size = 14, color = 'currentColor' }) => d(size, color, <>
  <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z" /><line x1="4" y1="22" x2="4" y2="15" />
</>);

export const IconWrench = ({ size = 14, color = 'currentColor' }) => d(size, color, <>
  <path d="M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z" />
</>);

export const IconLightbulb = ({ size = 14, color = 'currentColor' }) => d(size, color, <>
  <line x1="9" y1="18" x2="15" y2="18" /><line x1="10" y1="22" x2="14" y2="22" />
  <path d="M15.09 14c.18-.98.65-1.74 1.41-2.5A4.65 4.65 0 0018 8 6 6 0 006 8c0 1 .23 2.23 1.5 3.5A4.61 4.61 0 018.91 14" />
</>);

export const IconGamepad = ({ size = 14, color = 'currentColor' }) => d(size, color, <>
  <line x1="6" y1="12" x2="10" y2="12" /><line x1="8" y1="10" x2="8" y2="14" />
  <line x1="15" y1="13" x2="15.01" y2="13" /><line x1="18" y1="11" x2="18.01" y2="11" />
  <rect x="2" y="6" width="20" height="12" rx="2" />
</>);

export const IconMonitor = ({ size = 14, color = 'currentColor' }) => d(size, color, <>
  <rect x="2" y="3" width="20" height="14" rx="2" ry="2" /><line x1="8" y1="21" x2="16" y2="21" /><line x1="12" y1="17" x2="12" y2="21" />
</>);

export const IconKnife = ({ size = 14, color = 'currentColor' }) => d(size, color, <>
  <path d="M14.5 2L4 18h4l2 4 10.5-16z" />
</>, true);

export const IconCalendar = ({ size = 14, color = 'currentColor' }) => d(size, color, <>
  <rect x="3" y="4" width="18" height="18" rx="2" ry="2" /><line x1="16" y1="2" x2="16" y2="6" />
  <line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" />
</>);

export const IconPlus = ({ size = 14, color = 'currentColor' }) => d(size, color, <>
  <line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" />
</>);

export const IconCornerDownRight = ({ size = 14, color = 'currentColor' }) => d(size, color, <>
  <polyline points="15 10 20 15 15 20" /><path d="M4 4v7a4 4 0 004 4h12" />
</>);

export const IconUploadCloud = ({ size = 14, color = 'currentColor' }) => d(size, color, <>
  <polyline points="16 16 12 12 8 16" /><line x1="12" y1="12" x2="12" y2="21" />
  <path d="M20.39 18.39A5 5 0 0018 9h-1.26A8 8 0 103 16.3" />
</>);

export const IconEye = ({ size = 14, color = 'currentColor' }) => d(size, color, <>
  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" /><circle cx="12" cy="12" r="3" />
</>);

export const IconEyeOff = ({ size = 14, color = 'currentColor' }) => d(size, color, <>
  <path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24" />
  <line x1="1" y1="1" x2="23" y2="23" />
</>);

export const IconExternalLink = ({ size = 14, color = 'currentColor' }) => d(size, color, <>
  <path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6" />
  <polyline points="15 3 21 3 21 9" />
  <line x1="10" y1="14" x2="21" y2="3" />
</>);

export const IconArchive = ({ size = 14, color = 'currentColor' }) => d(size, color, <>
  <polyline points="21 8 21 21 3 21 3 8" />
  <rect x="1" y="3" width="22" height="5" />
  <line x1="10" y1="12" x2="14" y2="12" />
</>);
